import React from "react";
import styled, { css } from "styled-components";

import Toolbar from "../containers/Toolbar";
import { IconThumbsDownLine } from "../icons";
import IconThumbsUpLine from "../icons/IconThumbsUpLine";

const Styled = styled.div``;

type ButtonProps = {
  checked?: boolean;
};
const Button = styled.button<ButtonProps>`
  border: none;
  background-color: #eee;
  font-family: inherit;
  font-size: inherit;
  flex: 1;
  padding: 1.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.4rem;
  align-items: center;

  ${(props) => {
    if (props.checked) {
      return css`
        color: white;

        svg {
          fill: currentColor;
        }
      `;
    }
  }}
`;
const GoodButton = styled(Button)<ButtonProps>`
  ${(props) => {
    if (props.checked) {
      return css`
        background-color: #269426;
      `;
    }
  }}
`;
const BadButton = styled(Button)<ButtonProps>`
  ${(props) => {
    if (props.checked) {
      return css`
        background-color: #da0707;
      `;
    }
  }}
`;

const FeedbackInput = (props: {
  value?: 1 | 0;
  onChange?: (value: 1 | 0) => void;
}) => {
  return (
    <Styled>
      <Toolbar>
        <GoodButton
          checked={props.value === 1}
          onClick={() => props.onChange?.(1)}
        >
          <IconThumbsUpLine width="32" />
          <div>Good</div>
        </GoodButton>
        <BadButton
          checked={props.value === 0}
          onClick={() => props.onChange?.(0)}
        >
          <IconThumbsDownLine width="32" />
          <div>Bad</div>
        </BadButton>
      </Toolbar>
    </Styled>
  );
};

export default FeedbackInput;
